export function getPostAuthPath(searchParams) {
  const params = toSearchParams(searchParams);
  const tier = params.get('tier');
  const redirect = params.get('redirect');
  if (tier && redirect === 'checkout') {
    return `/account/upgrade?tier=${encodeURIComponent(tier)}`;
  }
  const url = params.get('url');
  if (url && url.length <= 500 && !/[\r\n]/.test(url)) {
    return `/?url=${encodeURIComponent(url)}`;
  }
  return '/';
}

export function withAuthQuery(path, searchParams) {
  const params = toSearchParams(searchParams);
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}

export function getOAuthRedirectTo() {
  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  const qs = typeof window === 'undefined' ? '' : window.location.search;
  return `${origin}/auth/callback${qs || ''}`;
}

function toSearchParams(searchParams) {
  if (searchParams instanceof URLSearchParams) {
    return searchParams;
  }
  return new URLSearchParams(searchParams || '');
}
